import { z } from 'zod'
import { newPasswordSchema } from './auth.ts'

export const profileSchema = z.object({
  fullName: z
    .string()
    .min(1, 'Full name is required')
    .max(100, 'Full name is too long'),
})

export const syncSettingsSchema = z.object({
  autoSync: z.boolean().default(false),
  syncInterval: z.enum(['hourly', 'daily', 'weekly']).default('daily'),
  notifyOnError: z.boolean().default(true),
  notifyOnSuccess: z.boolean().default(false),
})

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: newPasswordSchema,
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.newPassword !== data.currentPassword, {
    message: 'New password must be different from current password',
    path: ['newPassword'],
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  })

export type ProfileInput = z.infer<typeof profileSchema>
export type SyncSettingsInput = z.infer<typeof syncSettingsSchema>
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>
